<template>
  <div :style="disabled ? 'cursor: not-allowed;' : ''">
    <ckeditor :config="config" :disabled="disabled" :editor="editor" :value="valueComputed" @input="onInput" />
  </div>
</template>

<script>
  export default {
    name: "genexCkeditor",
    data() {
      return {};
    },
    props: {
      value: String,
      config: Object,
      editor: Function,
      // class: String,
      disabled: Boolean,
    },
    methods: {
      onInput(e) {
        this.$emit("input", e);
      },
    },
    computed: {
      valueComputed() {
        if ([null, ""].includes(this.value)) {
          return "<p style='text-align: justify;'></p>";
        } else {
          return this.value;
        }
      },
    },
  };
</script>
